import { render, staticRenderFns } from "./DetailStatistics.vue?vue&type=template&id=02603c95&scoped=true&"
import script from "./DetailStatistics.vue?vue&type=script&lang=js&"
export * from "./DetailStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02603c95",
  null
  
)

export default component.exports